import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { TSharholderUpdateData } from "../../stores/shareholder-store";

export const apiCallGetShareholderUpdateData = async ({
  dateRangeMonths
}: {
  dateRangeMonths: number;
}): Promise<{
  data: TSharholderUpdateData[] | number;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TSharholderUpdateData[]>(
    `shareholder/getShareholderUpdate`,
    {
      dateRangeMonths
    }
  );

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: 0,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: 0,
      status: "ERROR",
      code: "ERROR"
    };
  }
};
